import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { useAuth } from '@fetmode/app-core';
import { t } from '@fetmode/i18n';

export function ModelModePassAffiliateCard(): ReactElement {
  const { api } = useAuth();
  const [affiliateCode, setAffiliateCode] = useState<string>('');
  const [referralCount, setReferralCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    void api
      .getModePassAffiliateStats()
      .then((result) => {
        setAffiliateCode(result.affiliateCode);
        setReferralCount(result.referralCount);
      })
      .catch(() => {
        setAffiliateCode('');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [api]);

  if (isLoading) {
    return (
      <p style={{ color: 'var(--fm-color-text-muted)' }}>
        {t('common.studio.modePassAffiliate.loading')}
      </p>
    );
  }

  return (
    <div className="fm-card">
      <h2 style={{ marginTop: 0, fontSize: '1rem' }}>
        {t('common.studio.modePassAffiliate.title')}
      </h2>
      <p style={{ margin: '0 0 0.5rem', color: 'var(--fm-color-text-muted)', fontSize: '0.875rem' }}>
        {t('common.studio.modePassAffiliate.hint')}
      </p>
      <p style={{ margin: 0, fontSize: '0.875rem' }}>
        {t('common.studio.modePassAffiliate.code').replace('{{code}}', affiliateCode || '—')}
      </p>
      <p style={{ margin: '0.25rem 0 0', fontSize: '0.875rem' }}>
        {t('common.studio.modePassAffiliate.referrals').replace(
          '{{count}}',
          String(referralCount),
        )}
      </p>
    </div>
  );
}
